import { Field } from 'formik';
import sortCinemas from '../../../functions/sortCinemas';
import MultiselectCheckboxCinemas from './MultiselectCheckboxCinemas';

const MultiselectCheckboxCinemasRow = ({ clientCinemaId, cliCinemas, enabledCinemaIds }) => {

    

    const cliCinemasIdList = sortCinemas(clientCinemaId, cliCinemas)

    return (
        cliCinemasIdList.length > 1 ? (
            <fieldset className="field-cinemas">
                <legend className="field-text-label">Kinos</legend>

                <div className="select-all-cinemas-button-wrapper">  
                    <div key={'field-all'} className="field-checkbox">
                        <Field 
                            key={'all'} 
                            attrid={'all'}
                            name="cinemas"
                            component={MultiselectCheckboxCinemas} 
                            id={'alle anwählen'}
                            clicinemas={'all'}
                            enabledCinemaIds={enabledCinemaIds}
                            value={cliCinemasIdList} 
                        />
                    </div>
                </div>

                <div className="grid-container">
                    {cliCinemasIdList.map(cinemaId => {
                        const cinema = cliCinemas[cinemaId]
                        const {pk, nameShort} = cinema

                        return (
                            <div key={'field' + pk} className="field-checkbox">
                                <Field 
                                    key={pk} 
                                    attrid={pk}
                                    name="cinemas"
                                    component={MultiselectCheckboxCinemas} 
                                    enabledCinemaIds={enabledCinemaIds}
                                    id={nameShort}
                                    clicinemas={cliCinemas}
                                    value={pk} 
                                />
                            </div>
                        )
                    })}
                </div>
            </fieldset>
        ) : ("")
    )
}

export default MultiselectCheckboxCinemasRow